import {compose} from "redux";

interface Options {
    reduxDevtoolsOptions: {
        name: string;
    };
}
const DEVTOOLS_NAME = "__REDUX_DEVTOOLS_EXTENSION_COMPOSE__";

/**
 * Creates a compose function that adds in support for Redux Devtools when available
 */
const createCompose = (options: Options): typeof compose => {
    const devTools = typeof window === "object" && window[DEVTOOLS_NAME];
    return devTools
        ? devTools({
              // Specify default extension’s options like name, actionsBlacklist, actionsCreators, serialize...
              ...(options.reduxDevtoolsOptions || {}),
          })
        : compose;
};

export {createCompose};
